
import { timeParse, timeFormat } from 'd3-time-format';

import {  scaleTime, scaleLinear } from 'd3-scale';

import { interpolateLab } from 'd3-interpolate';
import { extent } from 'd3-array';
import { axisTop, axisBottom } from 'd3-axis';
import { transition } from 'd3-transition';
import { nest } from 'd3-collection'; // deprecated

import { select } from 'd3-selection'

export const margin = { top: 20, right: 20, bottom: 10, left: 100 };
// Lazy responsiveness
export const width = window.innerWidth - margin.left - margin.right;
export const height = window.innerHeight - 100 - margin.top - margin.bottom;

// True Constants
const inputTimeParse = timeParse("%H:%M:%S");
const outputTimeFormat = timeFormat("%H:%M");

function calculate_slope(d) {
    /* Calculates speed (miles/minute) between any two train stations. */
    const slope = Math.abs((d[1].distance - d[0].distance) /
                    (d[1].arrival_time - d[0].arrival_time));
    return slope;
}

export const type_stops = (d,i) => {
  /* Type casting function used for reading the TYPE csv. */
  // trip_id,arrival_time,stop_id,pickup_type,drop_off_type
  return {
    trip_id: +d.trip_id,
    arrival_time: inputTimeParse(d.arrival_time),
    stop_id: +d.stop_id,
    distance: +d.cumulative_distance  // put this here to simplify for now, should really remap on the frontend.
  }
}

export const type_stations = (d, i) => {
  /* Type casting function used for reading the STATIONS csv. */
  // headers: stop_id,stop_name,stop_lat,stop_lon,stop_url,
  // wheelchair_accessible,cmulative_distancedistance
  return {
    stop_id: +d.stop_id,
    name: d.stop_name,
    distance: +d.cumulative_distance
  }
}

export const is_valid_time = (t) => {
    /* weird things happen between midnight and 1 AM. leave off for now. */
    if (t != null) {
        const hours = t.getHours();
        return (hours > 3) && (hours < 26); // depart starts at 25
    } else {
        return false;
    }
}


// These are the x and y scales.
const x = scaleTime()
    .range([0, width]);

const y = scaleLinear()
    .range([0, height]);

// this is for coloring.
const z = scaleLinear()
    // .domain([.00005, .0009])
    // Use Pandas to check the 10th and 90th percentiles.
    // orange is faster, purple is slower
    .domain([0.000006, 0.000012])
    .range(["purple", "orange"])
    .interpolate(interpolateLab);

const svg = select("#viz").append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
  .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

// Clipping with a rectangle.
svg.append("defs").append("clipPath")
    .attr("id", "clip")
  .append("rect")
    .attr("y", -margin.top)
    .attr("width", width)
    .attr("height", height + margin.top + margin.bottom);

// Let's make the true parent
svg.append('g')
   .attr("class", "train")

const svg_child = select(".train")

function render_axes(stations, parent, xScale, yScale) {

    // Scale the Y axis
    yScale.domain(extent(stations, function(d) { return d.distance; }));
    var station = parent.append("g")
        .attr("class", "station")
      .selectAll("g")
        .data(stations)
      .enter().append("g")
        .attr("transform", function(d) { return "translate(0," + yScale(d.distance) + ")"; });

    // Y axis labels
    station.append("text")
        .attr("x", -20)
        .attr("dy", ".3em")
        .text(function(d) { return d.name; });

    // Horizontal lines
    station.append("line")
        .attr("x2", width);

    // Scale the X Axis
    const n_ticks = 12;
    const xAxisTop = axisTop(xScale)
        .ticks(n_ticks)
        .tickFormat(outputTimeFormat);

    const xAxisBottom = axisBottom(xScale)
        .ticks(n_ticks)
        .tickFormat(outputTimeFormat);
    parent.append("g")
        .attr("class", "x top axis")
        .call(xAxisTop);

    parent.append("g")
        .attr("class", "x bottom axis")
        .attr("transform", `translate(0, ${height})`)
        .call(xAxisBottom);
}

function render_train_dots(stops_by_trip, parent, xScale, yScale, colorScale) {
    /*
        Rollup stops into stops_by_trip
    */
    // Create SVG for each train trip. Each of these has a circle AND a line.
    let train = parent.selectAll("g")
        .data(stops_by_trip)
      .enter().append("g");

    // Add a bullet for each train
    train.selectAll("circle")
      .data(function(d) { return d.values })
    .enter().append("circle")
      .attr("transform", (d) => `translate(${xScale(d.arrival_time)}, ${yScale(d.distance)} )` )
      .attr("r", (d, i) => (i === 0) ? 2.5 : 2 )
      .attr("opacity", (d, i) => (i === 0) ? 0.9 : 0.30 ); // Fade out the non-initial stops.


    // We want some lines too!
    // train.selectAll("line")
    //     .data(function(d) { return d.values.slice(1).map(function(b, i) { return [d.values[i], b]; }); })
    //   .enter().append("line")
    //     .attr("x1", function(d) { return x(d[0].arrival_time); })
    //     .attr("x2", function(d) { return x(d[1].arrival_time); })
    //     .attr("y1", function(d) { return y(d[0].distance); })
    //     .attr("y2", function(d) { return y(d[1].distance); })
    //     .style("stroke", function(d) { return colorScale(calculate_slope(d)); });
}

function update_train_dots(stops_by_trip, parent, xScale, yScale, colorScale) {
    /*
        Rollup stops into stops_by_trip
    */
    // Initial data bind
    var t = transition()
              .duration(300);

    let trainGroups = parent.selectAll("g")
          .data(stops_by_trip, (d) => d.name);

    // Remove old items
    trainGroups.exit()
                // .transition(t)
                .style("fill-opacity", 1e-6)
                .remove()

    // Add new circles
    let enter = trainGroups.enter()
        .append('g');

    trainGroups = enter.merge(trainGroups);

    trainGroups.selectAll('circle')
        .data(function(d) { return d.values })
    .enter().append("circle")
          .attr("transform", (d) => `translate(${xScale(d.arrival_time)}, ${yScale(d.distance)} )` )
          .attr("r", (d, i) => (i == 0) ? 2.5 : 2 )
        // .transition(t)
          .attr("opacity", (d, i) => (i == 0) ? 0.9 : 0.3 )

    trainGroups.selectAll("line")
        .data(function(d) { return d.values.slice(1).map(function(b, i) { return [d.values[i], b]; }); })
      .enter().append("line")
        .attr("x1", function(d) { return x(d[0].arrival_time); })
        .attr("y1", function(d) { return y(d[0].distance); })
        .attr("x2", function(d) { return x(d[1].arrival_time); })
        .attr("y2", function(d) { return y(d[1].distance); })
        // .transition(t)
          .style("stroke", function(d) { return colorScale(calculate_slope(d)); });
}

function render_chart(stations, stop_times, parent, xScale, yScale, colorScale) {
    /*
        stations: an array of station objects
        stop_times: an array of stop_times (not grouped yet)
        Note this chart doesn't have a yAxis.
     */
      xScale.domain(extent([inputTimeParse("03:00:00"), inputTimeParse("23:59:00")]))  // bind once until we can figure out how to redraw the axes.);
      // xScale.domain(d3.extent(stop_times, function(d) { return d.arrival_time; }));
      let stops_by_trip = nest()
          .key(function(d) { return d.trip_id; })
          .entries(stop_times);

      render_axes(stations, svg, xScale, yScale);  // accesses global to avoid update problems.
      update_train_dots(stops_by_trip, parent, xScale, yScale, colorScale);
}

// Run these functions last.
const trip_count_input = document.getElementById("max_trips");
const INITIAL_TRIP_COUNT = 800;
// trip_count_input.value = INITIAL_TRIP_COUNT; // only run this once max_trips is defined
let all_stops = [];
let all_stations = [];

function refreshChart(e) {
    e.preventDefault();
    let max_trips = trip_count_input.value;
    let stop_times = all_stops.slice(0, max_trips);

    let stops_by_trip = nest()
          .key(function(d) { return d.trip_id; })
          .entries(stop_times);

    //
    // console.log(stops_by_trip);

    // Only include trips with at least 1 stop in Stamford

    // update_train_dots(stops_by_trip, svg_child, x, y, z);  // svg_child is the child of svg
    render_chart(all_stations, stop_times, svg_child, x, y, z);
}




// TODO: event handling only if defined
// document.getElementById("basicForm").addEventListener("submit", refreshChart);
